module.exports = __webpack_public_path__ + "img/p_22_s.37c9e79d.png";